import React, { useState } from 'react';
import cn from 'classnames';
import withBlueBookPlayer from 'chameleon/packages/blue-book-player/hocs/withBlueBookPlayer';

const withBlueBookTeacherPlayer = (WrappedComponent) => {
  const BlueBookTeacherPlayerWrapper = (props) => {
    const [areDetailsExpanded, setAreDetailsExpanded] = useState(false);

    return (
      <div
        className={cn('question-preview-player', {
          'question-details-expanded': areDetailsExpanded,
        })}
      >
        <WrappedComponent
          {...props}
          setAreDetailsExpanded={setAreDetailsExpanded}
          areDetailsExpanded={areDetailsExpanded}
        />
      </div>
    );
  };

  return withBlueBookPlayer(BlueBookTeacherPlayerWrapper);
};

export default withBlueBookTeacherPlayer;
